import dayjs from 'dayjs';
import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { ModelType } from '/@/modules/core/app/constants/ModelType';
import { TimeEntryMeta, TimeEntryMetaType } from '/@/modules/timeentry/models/meta/TimeEntryMeta';
import { minuteDurationToTime } from '/@/modules/core/app/helpers/DateHelper';
import { DateFormat } from '/@/modules/core/app/constants/date.constants';
import { Estate } from '@/modules/estate/models/Estate';
import { User } from '@/modules/user/models/User';
import { TimeEntryTypeKey } from '@/modules/timeentry/constants/TimeEntryTypeKey';
import { TimeEntrySubTypeKey } from '@/modules/timeentry/constants/TimeEntrySubTypeKey';
import { EstateTask } from '@/modules/estatetask/models/EstateTask';

export class TimeEntry extends BaseEntityModel {
  id?: number;
  userId?: number;
  estateId?: number;
  type?: TimeEntryTypeKey;
  subType?: TimeEntrySubTypeKey;
  duration?: number;
  startedAt?: string;
  meta?: TimeEntryMetaType;
  description?: string;
  isAiUsed?: boolean;
  modelType?: string;
  modelId?: number;
  user?: Relationship<User | null>;
  estate?: Relationship<Estate | null>;
  estateTask?: Relationship<EstateTask | null>;

  constructor(model: Partial<TimeEntry> = {}) {
    super(model);

    this.id = model.id;
    this.userId = model.userId;
    this.estateId = model.estateId;
    this.subType = model.subType;
    this.duration = model.duration;
    this.startedAt = model.startedAt;
    this.meta = model.meta;
    this.description = model.description;
    this.isAiUsed = model.isAiUsed ?? false;
    this.modelType = model.modelType;
    this.modelId = model.modelId;
    this.setType(model.type);

    // @ts-ignore
    this.user = User.mapModelOrNull(model.user);
    // @ts-ignore
    this.estate = Estate.mapModelOrNull(model.estate);
    // @ts-ignore
    this.estateTask = EstateTask.mapModelOrNull(model.estateTask);
  }

  getModelName(): ModelType {
    return ModelType.TIME_ENTRY;
  }

  setType(value: TimeEntryTypeKey | undefined): void {
    this.type = value;
    this.meta = TimeEntryMeta.factory(this.type, this.meta ?? {}) ?? undefined;
  }

  get durationFormatted(): string {
    return minuteDurationToTime(this.duration);
  }

  get formattedStartedAt(): string {
    return dayjs(this.startedAt).utc().format(DateFormat.MONTH_DAY_YEAR);
  }
}
